export default "__VITE_ASSET__DLsXlO4O__"